<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12 list-content nopads">
    <Transition name="fade">
      <div
        v-if="culvertList.length > 0"
        class="list-content result-table pointer"
      >
        <vue3-datatable
          ref="resultTable"
          :rows="culvertList"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="100%"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
          @row-click="rowClicked"
        />
      </div>
    </Transition>
  </div>
</template>

<script>


import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'CulvertList',
    components: {Vue3Datatable},
    props: {
        culverts: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            culvertList: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'digiroad_id', title: this.$t('culvert.digiroad_id'), sort: true, headerClass: 'routa-table-header'},
                {field: 'type', title: this.$t('bridge.type'), sort: true, headerClass: 'routa-table-header'},
                {field: 'material', title: this.$t('culvert.material'), sort: true, headerClass: 'routa-table-header'},
                {field: 'size', title: this.$t('culvert.size'), sort: true, headerClass: 'routa-table-header'},
                {field: 'length', title: this.$t('bridge.length'), sort: true, headerClass: 'routa-table-header'},
                {field: 'start_distance', title: this.$t('bridge.start_distance'), sort: true, headerClass: 'routa-table-header'},
                {field: 'city', title: this.$t('bridge.city'), sort: true, headerClass: 'routa-table-header'},
                {field: 'road_num', title: this.$t('bridge.road_num'), sort: true, headerClass: 'routa-table-header'},
                {field: 'sec_num', title: this.$t('bridge.sec_num'), sort: true, headerClass: 'routa-table-header'},
                {field: 'owner', title: this.$t('culvert.owner'), sort: true, headerClass: 'routa-table-header'},
                {field: 'job_area', title: this.$t('bridge.job'), sort: true, headerClass: 'routa-table-header'}]
        }
    },
    watch: {
        culverts() {
            this.culvertList = []
            this.$nextTick(() => {
                this.culvertList = this.culverts
            })
        }
    },
    mounted() {
        this.culvertList = this.culverts
    },
    methods: {
        rowClicked: function (details) {
            this.$emit('rowClicked', details)
        }
    }
}
</script>
